export default {
  "content": "<g clip-path=\"url(#a)\"><path fill=\"#3F4450\" d=\"M23.709 11.645L12.354.289a1.003 1.003 0 10-1.418 1.42l.17.17-8.2 14.51-1.2-1.2a1.003 1.003 0 10-1.418 1.42l4.968 4.968 2.131 2.132a1.004 1.004 0 001.419-1.42L7.611 21.1l1.814-1.03 1.156 1.158a4.515 4.515 0 006.93-5.728l4.61-2.604.17.168a1.003 1.003 0 001.418-1.418zm-8.516-5.678L5.78 15.38l6.8-12.028 2.613 2.615zm1.09 12.065A2.508 2.508 0 0112 19.806l-.761-.762 4.506-2.544c.346.435.536.975.538 1.532z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none"
  }
};